










































































































































































































































































































































































import { Anagrafica } from "@/data/models/anagrafica.model";
import { AnagraficaService } from "@/data/services/anagrafica.service";
import { Component, Inject, Vue } from "vue-property-decorator";
import "@/plugins/filters";
import { download } from "yellowfin-ui-lib";
import packageInfo from "../../../package.json";

@Component
export default class AlboDetail extends Vue {
  @Inject("AnagraficaService") anagraficaService!: AnagraficaService;

  anagrafica!: Anagrafica;
  loading = false;
  baseurl: string = "";

  ordine?: string = process.env.VUE_APP_ORDINE;

  get dataintera() {
    return (process.env.VUE_APP_LAUREA_DATA_INTERA as string) === "true";
  }

  get showsettore() {
    return (process.env.VUE_APP_SETTORE_HIDE as string) === "false";
  }

  get showprovvedimenti() {
    return (process.env.VUE_APP_PROVVEDIMENTI_SHOW as string) === "true";
  }

  get settore(): string {
    const s = [];
    if (this.anagrafica.settorea) s.push("Civile e Ambientale");
    if (this.anagrafica.settoreb) s.push("Industriale");
    if (this.anagrafica.settorec) s.push("Informazione");
    return s.join(" - ");
  }

  get settore2(): string {
    const s = [];
    if (this.anagrafica.settAsez2) s.push("Civile e Ambientale");
    if (this.anagrafica.settBsez2) s.push("Industriale");
    if (this.anagrafica.settCsez2) s.push("Informazione");
    return s.join(" - ");
  }

  downloadCv() {
    // @ts-ignore

    if (this.anagrafica.curriculum) {
      const nome = this.anagrafica.nomecv
        ? this.anagrafica.nomecv
        : this.anagrafica.nome + "-" + this.anagrafica.cognome + "-cv.pdf";
      this.anagraficaService
        .downloadcv(this.anagrafica.curriculum)
        .then((result) => {
          download(result, nome);
        });
    }
  }

  loadAnagrafica(id: number) {
    this.loading = true;
    this.anagraficaService
      .getAnagrafica(id)
      .then((result) => {
        this.anagrafica = result;
      })
      .finally(() => (this.loading = false));
  }

  beforeMount() {
    console.log(`UI v. ${packageInfo.version}`);

    const uri = window.location.search.substring(1);
    const params = new URLSearchParams(uri);
    // const path = location.pathname.split('/');
    const id = params.get("profileid"); //12;//this.$route.query.test;//path[1]
    if (id) {
      this.loadAnagrafica(+id);
    }
    this.baseurl = window.location.href.split("?")[0];
  }
}
